<template>
    <div class="tool-card" :class="[`card-${size}`]" @click="handleCard(data)">
        <template v-if="size === 'default'">
            <div class="card-image">
                <img v-lazy="data.image" />
            </div>
            <div class="card-info">
                <div class="card-info__title">
                    <svg-icon icon-class="link" :class-name="data.isabroad === 0 ? 'icon-link-green' : 'icon-link'"></svg-icon>
                    <span>{{ data.title || '' }}</span>
                </div>
                <div class="card-info__action">
                    <svg-icon icon-class="follow" class-name="icon-follow"></svg-icon>
                    {{ data.follow }}
                </div>
            </div>
        </template>
        <template v-if="size === 'mini'">
            <div class="card-image" v-if="data.image">
                <img v-lazy="data.image" />
            </div>
            <div class="card-info" :class="{ noImage: !data.image }">
                <div class="card-info__title">{{ data.title || '' }}</div>
                <div class="card-info__subtitle">{{ data.subtitle || '' }}</div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'ToolCard',
    props: {
        size: {
            type: String,
            default: 'default'
        },
        data: {
            type: Object,
            default: () => {}
        },
    },
    methods: {
        handleCard(data) {
            this.$emit('handleCard', data);
        }
    }
};
</script>

<style lang="scss" scoped>
.card-default {
    transition: transform 0.35s;
    transform: translateZ(0);
    overflow: hidden;
    cursor: pointer;

    &:hover {

        .card-image img {
            transform: scale(1.05);
        }
    }

    .card-image {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        border-radius: 4px;
        overflow: hidden;
        background-color: #fff;

        img {
            width: 300px;
            height: 200px;
            transition: transform 0.35s;
        }
    }

    .card-info {
        position: relative;
        padding: 5px 0;

        &__title,
        &__subtitle {
            width: 200px;
            height: 30px;
            line-height: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        &__title {
            @include font(rgba(39, 44, 64, 1), 14px, 600);

            &:hover {
                color: rgba(47, 84, 235, 1);
            }

            .icon-link {
                margin-right: 5px;
                color: rgba(47, 84, 235, 1);
            }

            .icon-link-green {
                margin-right: 5px;
                color: #1AC72A;
            }
        }

        &__subtitle {
            @include font(rgba(90, 90, 90, 1), 14px, 400);
        }

        &__action {
            position: absolute;
            right: 0px;
            bottom: 5px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            color: #a8adc1;

            .icon-follow {
                color: #a8adc1;
            }
        }
    }
}

.card-mini {
    display: flex;
    height: 100px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    transition: transform 0.35s;
    transform: translateZ(0);
    overflow: hidden;
    cursor: pointer;

    &:hover {
        transform: translate(0, -5px);

        .card-image img {
            transform: scale(1.05);
        }
    }

    .card-image {
        flex: 0 0 33%;
        width: 100px;
        height: 100px;
        overflow: hidden;

        img {
            width: 100px;
            height: 100px;
            transition: transform 0.35s;
        }
    }
    .card-info {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        padding: 0 12px;
        width: 67%;

        &.noImage {
            border: 1px solid rgba(224, 228, 247, 1);
            border-radius: 10px;
        }

        &__title {
            height: 40px;
            line-height: 40px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            @include font(rgba(39, 44, 64, 1), 14px, 600);
        }
        &__subtitle {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            height: 40px;
            line-height: 20px;
            @include font(rgba(123, 129, 159, 1), 14px, 300);
        }
    }
}


// 小屏
@include mq($small) {
    .card-default {
        .card-image {
            height: 150px;

            img {
                width: 225px;
                height: 150px;
            }
        }

        .card-info {
            position: relative;
            padding: 5px 0;

            &__title,
            &__subtitle {
                width: 150px;
                height: 22px;
                line-height: 22px;
            }
            &__title {
                @include font(rgba(39, 44, 64, 1), 12px, 600);
            }

            &__subtitle {
                @include font(rgba(90, 90, 90, 1), 12px, 400);
            }

            &__action {
                height: 22px;
                line-height: 22px;
                font-size: 14px;
            }
        }
    }
    .card-mini {
        height: 75px;

        .card-image {
            width: 75px;
            height: 75px;
            overflow: hidden;

            img {
                width: 75px;
                height: 75px;
            }
        }
        .card-info {
            padding: 0 9px;

            &__title {
                height: 30px;
                line-height: 30px;
                @include font(rgba(39, 44, 64, 1), 12px, 600);
            }
            &__subtitle {
                height: 30px;
                line-height: 15px;
                @include font(rgba(123, 129, 159, 1), 12px, 300);
            }
        }
    }
}
</style>
